module.exports = __webpack_public_path__ + "8c99bfc31c5eabbaccc1db5a5250c5c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/POS-2-02.png
// module id = 538
// module chunks = 0